import React, {  useState } from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import CustomAccordion from "../../../utils/CustomAccordian/CustomAccordian";
import AccordionChild from "../../../utils/CommonAccordianChild/AccordionChild";
import { darkTheme } from "../../../theme/Theme";
import {
  accordionContent,
  generateSectionData,
} from "../../../utils/function";
import Summary from "../Components/Summary";
import { Button } from "pepsico-ds";
import { useNavigate } from "react-router-dom";

export default function TabData({ currentTabData, activeTab,navPathUrl }) {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const isDarkTheme = useSelector((store) => store.theme);
  const navigate = useNavigate();
  const handleAccordionToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const HeaderTitle = () => {
    switch (activeTab) {
      case 0:
        return "All";
      case 1:
        return "Documents";
      case 2:
        return "Videos";
      case 3:
        return "Links";

      default:
        return "";
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        padding: "16px",
        alignItems: "flex-start",
        gap: "16px",
        alignSelf: "stretch",
        borderRadius: "16px",
        background: isDarkTheme ? darkTheme.backgroundColorLayer2 : "#FBFCFE",
        boxShadow:
          "var(--Elevation-X-Elevation-03, 0px) var(--Elevation-Y-Elevation-03, 2px) var(--Elevation-Blur-Elevation-03, 24px) var(--Elevation-Spread-Elevation-03, 8px) var(--Elevation-Colors-Elevation-03, rgba(0, 92, 188, 0.12))",
      }}
    >
      <h6
        className={`${
          isDarkTheme ? "text-[#EDEDED]" : "text-[#3A3A3A]"
        }  font-bold`}
      >
        {HeaderTitle()}
      </h6>
      {currentTabData?.map((accordion, index) => (
        <CustomAccordion
          key={accordion.contentGuid}
          headerText={accordion?.title}
          footerText={accordion?.uploadedBy}
          expanded={expandedIndex === index}
          onToggle={() => handleAccordionToggle(index)}
        >
          <AccordionChild
            accordionContent={accordionContent(accordion)}
            sectionData={generateSectionData(accordion)}
            component={
              <Summary
                label={"Summary"}
                description={accordion?.summary}
              />
            }
          />
          <Box
            sx={{
              background: isDarkTheme
                ? darkTheme.backgroundColorLayer2
                : "#F3F7FD",
            }}
          >
            <Button
              size="medium"
              style={{
                // border: isDarkTheme ? "1px solid #616161" : "1px solid #D7E5F8",
                border: "none",
                fontWeight: 700,
                color: "#005CBC",
                fontSize: 14,
                margin: "16px 0",
                marginLeft: "auto",
              }}
              text="Edit, review and publish"
              variant="secondary"
              isDark={isDarkTheme}
              iconTrailing="arrow_forward"
              onClick={() =>
                navigate(`${navPathUrl}/${accordion?.contentGuid}`)
              }
            />
          </Box>
        </CustomAccordion>
      ))}
      {currentTabData?.length === 0 && (
        <span style={{ display: "flex", justifyContent: "center" }}>
          No records found.
        </span>
      )}
    </Box>
  );
}
